import { render, staticRenderFns } from "./UserSettings.vue?vue&type=template&id=7471a15e"
import script from "../../script/user/userSettings.js?vue&type=script&lang=js&external"
export * from "../../script/user/userSettings.js?vue&type=script&lang=js&external"
import style0 from "../../less/user/userSettings.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports